import { events } from '../../Constants';
import { logAddPersonalisedDate, logAddPersonalisedMessage } from '../../analytics';
import { initCanvas, refreshDesignAndText } from './canvas';
import { DesignLabels, Designs, PotColors } from './constants';
import { handleAddToCart, initDesignOptions, updateCustomisationOptions } from './core';

const refresh = () => {
  const colorInputCtr = document.querySelector('.js-select-color-options');
  const colorInput = colorInputCtr.querySelector('input[name="Color"]:checked');
  const customTextInput = document.querySelector('.js-engraving-custom-text');
  const customTextInput2 = document.querySelector('.js-engraving-custom-text-2');
  const designInputCtr = document.querySelector('input[name="design-option"]:checked');
  const dateInputCtr = document.querySelector('.js-engraving-date-picker') as HTMLInputElement;

  const potColor = ((colorInput || document.querySelector('input[name="Color"]')) as HTMLInputElement).value;
  const engravingDesign = (designInputCtr as HTMLInputElement).value;
  const customText = (customTextInput as HTMLInputElement).value;
  const customText2 = (customTextInput2 as HTMLInputElement).value;

  refreshDesignAndText({
    // eslint-disable-next-line no-nested-ternary
    potColor: potColor === 'Glossy White' ? PotColors.GLOSSY_WHITE
      : (potColor === 'Matte White' ? PotColors.MATTE_WHITE : PotColors.FUCHSIA),
    engravingDesign,
    customText,
    customText2,
    customDate: dateInputCtr.value,
  });
};

const handleDesignChange = (e: InputEvent) => {
  const selectedDesign = (e.target as HTMLInputElement).value;
  const selectedDesignInfoEl = document.querySelector('.js-selected-engraving-design') as HTMLElement;
  const customTextInput: HTMLInputElement = document.querySelector('.js-engraving-custom-text');

  if (!customTextInput.hasAttribute('is-dirty')) {
    if (selectedDesign !== Designs.CUSTOM_TEXT) {
      customTextInput.value = '';
    } else {
      customTextInput.value = 'Sample Text 1';
    }
  }

  selectedDesignInfoEl.innerText = DesignLabels[selectedDesign];
  updateCustomisationOptions(selectedDesign);
  refresh();
};

const handleTextInput = (e: InputEvent) => {
  const { target } = e;
  e.preventDefault();
  e.stopPropagation();

  (target as HTMLInputElement).value = (target as HTMLInputElement).value;

  refresh();
};

const handleTextChange = (e: InputEvent) => {
  const { target } = e;

  if ((target as HTMLInputElement).value) {
    logAddPersonalisedMessage(false);
  }
};

const handleTextInputFocus = (e: InputEvent) => {
  const customTextInput = e.target as HTMLInputElement;

  if (!customTextInput.hasAttribute('is-dirty')) {
    customTextInput.value = '';
    customTextInput.setAttribute('is-dirty', 'true');
    refresh();
  }
};

const addListeners = () => {
  const engravingDrawerTrigger = document.querySelector('[data-engraving-drawer-trigger]');
  const colorInputCtr = document.querySelector('.js-select-color-options');
  const sizeInputCtr = document.querySelector('.js-select-size');
  const customTextInput = document.querySelector('.js-engraving-custom-text');
  const customTextInput2 = document.querySelector('.js-engraving-custom-text-2');
  const designInputCtr = document.querySelector('.engraving-visualizer__design-options');
  const addToCartBtn = document.querySelector('.js-engraving-visualizer button[type="submit"]');
  const dateInputCtr = document.querySelector('.js-engraving-date-picker') as HTMLInputElement;
  const closeDrawerEl = document.querySelector('.engraving-vis-drawer__close');
  const $window = $(window);

  if (engravingDrawerTrigger) {
    engravingDrawerTrigger.addEventListener('click', () => {
      document.body.classList.add('engraving-vis-drawer--open');
      document.body.classList.remove('engraving-vis-drawer--closed');
      $window.trigger(events.overlay.show);
    });
  }

  if (closeDrawerEl) {
    closeDrawerEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.classList.add('engraving-vis-drawer--closed');
      document.body.classList.remove('engraving-vis-drawer--open');
      $window.trigger(events.overlay.hide);
    });
  }

  designInputCtr.addEventListener('change', handleDesignChange);
  customTextInput.addEventListener('input', handleTextInput);
  customTextInput.addEventListener('change', handleTextChange);
  customTextInput2.addEventListener('input', handleTextInput);
  customTextInput2.addEventListener('change', handleTextChange);
  customTextInput.addEventListener('focus', handleTextInputFocus);
  customTextInput2.addEventListener('focus', handleTextInputFocus);
  colorInputCtr.addEventListener('change', refresh);
  sizeInputCtr.addEventListener('change', refresh);
  addToCartBtn.addEventListener('click', handleAddToCart);
  dateInputCtr.addEventListener('onDateSelect', () => {
    logAddPersonalisedDate(false);
    refresh();
  });
};

const init = async () => {
  await initCanvas();

  initDesignOptions();
  addListeners();
  refresh();
};

init();
